<div class="ui-empty-state" [class.ui-empty-state--compact]="compact()">
  <div class="ui-empty-state__icon" aria-hidden="true">
    <ui-icon [name]="icon()" size="lg" />
  </div>
  <h3 class="ui-empty-state__title">{{ title() }}</h3>
  @if (description()) {
    <p class="ui-empty-state__description">{{ description() }}</p>
  }
  <div class="ui-empty-state__actions">
    <ng-content />
  </div>
</div>
